import { render, staticRenderFns } from "./previewSobre.vue?vue&type=template&id=2194b5d2"
import script from "./previewSobre.vue?vue&type=script&lang=js"
export * from "./previewSobre.vue?vue&type=script&lang=js"
import style0 from "./previewSobre.vue?vue&type=style&index=0&id=2194b5d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports